<div class="sidebar" [class.collapsed]="collapsed" [class.mobile-open]="mobileOpen">

    <div class="logo">
        <!-- <img src="./logo_new.jpg" alt="Logo" class="logo-img">
        <img src="./logo-m.png" alt="Logo" class="logo-mobile-img"> -->
        <!-- <img src="./mitra.png" alt="Logo" class="logo-img"> -->
        <img src="./newT1D.png" alt="T1DMitra Logo" class="logo-img">



    </div>

    <ul class="menu">
        <li *ngIf="roId === 2" routerLink="/admin/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [attr.title]="collapsed ? 'Dashboard' : null">
            <i class="bi bi-house"></i>
            <span>Dashboard</span>
        </li>

        <li *ngIf="roId === 2" routerLink="/admin/doctor-management" routerLinkActive="active" [attr.title]="collapsed ? 'Doctors' : null">
            <i class="bi bi-people"></i>
            <span>Doctors</span>
        </li>

        <li *ngIf="roId === 2" routerLink="/admin/menu-management" routerLinkActive="active" [attr.title]="collapsed ? 'Menu' : null">
            <i class="bi bi-list"></i>
            <span>Menu</span>
        </li>

        <li *ngIf="roId === 2" routerLink="/admin/resources" routerLinkActive="active" (click)="onResourcesMenuClick();"
            (keydown.enter)="onResourcesMenuClick()" (keydown.space)="onResourcesMenuClick();closeMenu.emit()"
            tabindex="0" [attr.title]="collapsed ? 'Resources' : null">
            <i class="bi bi-folder"></i>
            <span>Resource <Summary></Summary></span>
        </li>

        <li *ngIf="roId === 2" routerLink="/admin/manage-labels" routerLinkActive="active" [attr.title]="collapsed ? 'Manage Labels' : null">
            <i class="bi bi-translate"></i>
            <span>Manage Labels</span>
        </li>
        <li *ngIf="roId === 2" routerLink="/admin/feedback" routerLinkActive="active" [attr.title]="collapsed ? 'Feedback' : null">
            <i class="bi bi-chat-dots"></i>
            <span>Feedback</span>
        </li>
        <!-- <li routerLink="/admin/organization" routerLinkActive="active" [attr.title]="collapsed ? 'Organization' : null">
                <i class="bi bi-chat-dots"></i>
                <span>Organization</span>
                </li>  -->
        <li *ngIf="roId === 2"   routerLink="/admin/lookup" routerLinkActive="active" [attr.title]="collapsed ? 'Lookup Master' : null">
            <i class="bi bi-list"></i>
            <span>Lookup Master</span>
        </li>
        <li *ngIf="roId === 2" routerLink="/admin/organization" routerLinkActive="active" [attr.title]="collapsed ? 'Organization Master' : null">
            <i class="bi bi-building"></i>
            <span>Organization Master</span>
        </li>
        <li *ngIf="roId === 2" routerLink="/admin/reports" routerLinkActive="active" [attr.title]="collapsed ? 'Reports' : null">
            <i class="bi bi-graph-up"></i>
            <span>Reports</span>
        </li>
        <li *ngIf="roId === 2" routerLink="/admin/new-reports" routerLinkActive="active" [attr.title]="collapsed ? 'Daily Reports' : null">
            <i class="bi bi-calendar3"></i>
            <span>Daily Reports</span>
        </li>
        <li *ngIf="roId === 3"routerLink="/doctor/patient-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" [attr.title]="collapsed ? 'Patient Management' : null">
            <i class="bi bi-house"></i>
            <span>Patient Management</span>
        </li>
         <!-- like the admin Resources link: open the full list, not the translations view seen last -->
         <li *ngIf="roId === 3"routerLink="/doctor/resource-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="onResourcesMenuClick()" [attr.title]="collapsed ? 'Resource Management' : null">
            <i class="bi bi-folder"></i>
            <span>Resource Management</span>
        </li>
        <li *ngIf="roId === 3" routerLink="/doctor/daily-reports" routerLinkActive="active" [attr.title]="collapsed ? 'App Usage Report' : null">
            <i class="bi bi-calendar3"></i>
            <span>App Usage Report</span>
        </li>
    </ul>




    <!-- Bottom section -->
    <div class="sidebar-bottom">
        <!-- <button class="logout" type="button" (click)="logout()">
            <i class="bi bi-box-arrow-right"></i>
            <span>Logout</span>
        </button> -->
        <div class="sidebar-bottom-row">
            <div class="version">
                Version 2.0
            </div>
            <!-- desktop: collapse / expand the menu -->
            <button type="button" class="sidebar-toggle" [class.is-collapsed]="collapsed"
                [attr.aria-label]="collapsed ? 'Expand menu' : 'Collapse menu'" [attr.aria-expanded]="!collapsed"
                [title]="collapsed ? 'Expand menu' : 'Collapse menu'" (click)="toggleCollapse.emit()">
                <i class="bi bi-chevron-double-left"></i>
            </button>
        </div>
    </div>
</div>

<!-- <div class="sidebar-overlay" *ngIf="mobileOpen" (click)="closeMenu.emit()">
</div> -->

<button class="sidebar-overlay" *ngIf="mobileOpen" (click)="closeMenu.emit()" aria-label="Close menu overlay">
</button>